import { useEffect, useState } from 'react';
import { fetchProductsList } from '../services/cdn';

export const useProducts = (options = { showAll: false }) => {
    const [result, setResult] = useState<any>([])
    useEffect(() => {
        fetchProductsList?.().then?.((data) => {
            setResult(options?.showAll
                ? data
                : data?.filter?.((p: any) => p.isActive === true)
            )
        })
    }, [options?.showAll])

    return result;
}